export default __webpack_public_path__ + "static/media/bw_photos_hamptons-4.26afee9c.jpg";